import { queryOptions, useQuery } from '@tanstack/react-query';
import { SafeImage } from '@/components/common/safe-image';
import Icon from '@/components/icons/icon';
import type { RespondedWith } from '@/models/response';
import type { Sticker } from '@/models/sticker';
import { fetcher } from '@/utils/fetcher';
import type { SelectorItem } from '../symbol.type';

export const stickerCategoriesQueryOptions = queryOptions({
  queryKey: ['/GetEmoteClass'],
  queryFn: ({ signal }) =>
    fetcher<RespondedWith<Sticker[]>>('/GetEmoteClass', undefined, { signal, validResponseCodes: [0] }).then(
      (response) => response.Data?.filter((c) => c.ID !== 0) ?? [],
    ),
  placeholderData: [],
  staleTime: 30 * 24 * 60 * 60 * 1000,
  gcTime: 365 * 24 * 60 * 60 * 1000,
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
});

export default function useStickerCategories() {
  const query = useQuery({
    ...stickerCategoriesQueryOptions,
    select: (data) =>
      data.map(
        ({ ID: id, ImageUrl: url }): SelectorItem => ({
          slug: `sticker_category_${id}`,
          item: (
            <Icon>
              <SafeImage
                className='size-6 bg-cover'
                src={url}
              />
            </Icon>
          ),
        }),
      ),
  });

  return {
    stickerCategories: query.data ?? [],
    ...query,
  };
}
